import React from 'react';

/**
 * Brand splash / wait screen — shown while React is fetching auth or routing.
 * Visually matches the static pre-React splash in index.html so the transition
 * from "app launch" → "React mounted" is seamless.
 */
export default function SplashScreen({ subtitle = 'Loading Cut2Pro…' }) {
  return (
    <div className="fixed inset-0 z-[200] flex flex-col items-center justify-center"
      style={{ background: '#0E1B2C' }}
      data-testid="splash-screen">
      <img src="/logo-round.png" alt="Cut2Pro"
        className="h-40 w-40 rounded-full bg-white p-1.5 shadow-[0_30px_80px_-20px_rgba(0,0,0,0.6)]"
        style={{ animation: 'c2p-pulse 1.6s ease-in-out infinite' }} />
      <p className="mt-7 text-[11px] tracking-[0.18em] uppercase text-white/55">{subtitle}</p>
      <style>{`
        @keyframes c2p-pulse {
          0%, 100% { transform: scale(1); opacity: 0.92; }
          50%      { transform: scale(1.04); opacity: 1; }
        }
      `}</style>
    </div>
  );
}
